import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { optimizeImage } from '../utils/imageOptimizer';
import './NutritionPage.css';
import ScrollIndicator from './ScrollIndicator';

const NutritionPage = () => {
    // Shared background colors for sections
    const beigeBg = "#fdf6e6";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Product images
    const heroImg = "https://caninecrown.ascentbw.com/Image/Home/NutriHero.png";
    const dogCardImg = "https://caninecrown.ascentbw.com/Image/Home/Dog.png";
    const catCardImg = "https://caninecrown.ascentbw.com/Image/Home/Cat.png";

    return (
        <div className="nutrition-page" style={{ backgroundColor: beigeBg }}>
            {/* HERO SECTION */}
            <header className="nutrition-hero">
                <div className="nutrition-hero-bg hero-animate-down" style={{ backgroundImage: `url(${optimizeImage(heroImg, { width: 1440 })})` }}></div>
                <div className="nutrition-hero-overlay"></div>
                <div className="nutrition-hero-content hero-animate-up">
                    <div className="hero-left">
                        <h1 className="hero-title">Nutrition Designed<br />For Every Life Stage</h1>
                    </div>
                    <div className="hero-right">
                        <p className="hero-desc">
                            Discover scientifically formulated pet food designed for better health, vitality, and overall wellbeing.
                        </p>
                    </div>
                </div>
                <ScrollIndicator />
            </header>

            {/* TAILORED NUTRITION SECTION */}
            <section className="tailored-nutrition">
                <h2 className="section-title">Nutrition Tailored for Every Pet</h2>
                
                <div className="nutrition-cards-grid">
                    {/* Dog Card */}
                    <div className="nutrition-card">
                        <div className="card-image-content">
                            <img src={optimizeImage(dogCardImg, { width: 400, height: 400 })} alt="For Dogs" className="card-thumbnail" loading="lazy" />
                        </div>
                        <div className="card-text-content">
                            <h3>For Dogs</h3>
                            <p>Complete and balanced nutrition crafted for puppies and adult dogs to support strength, immunity, and vitality.</p>
                            <Link to="/dog-products" className="explore-btn">
                                Explore Dog Food
                                <span className="arrow-circle"><FaArrowRight /></span>
                            </Link>
                        </div>
                    </div>

                    {/* Cat Card */}
                    <div className="nutrition-card">
                        <div className="card-image-content">
                            <img src={optimizeImage(catCardImg, { width: 400, height: 400 })} alt="For Cats" className="card-thumbnail" loading="lazy" />
                        </div>
                        <div className="card-text-content">
                            <h3>For Cats</h3>
                            <p>Specially formulated recipes designed to meet the unique nutritional needs of cats at every life stage.</p>
                            <Link to="/cat-products" className="explore-btn">
                                Explore cat Food
                                <span className="arrow-circle"><FaArrowRight /></span>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default NutritionPage;
